module.exports = __webpack_public_path__ + "static/media/no_image_book.9c4bbb21.jpg";